module.exports = __webpack_public_path__ + "media/images/campaign_explain-59e5d8dcc7e319ae3731a15a3522da18.png";